import styled from 'styled-components';

export const EducationalParticlesContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
  overflow: hidden;

  .educational-particle {
    position: absolute;
    pointer-events: none;
    transition: all 0.3s ease-out;
    will-change: transform, opacity;
  }

  .educational-particle:hover {
    opacity: 0.3 !important;
    transform: scale(1.2) !important;
  }
`;

export const Particle = styled.div`
  position: absolute;
  pointer-events: none;
  transition: all 0.3s ease-out;
  will-change: transform, opacity;
`;
